import {CircularProgress} from "@mui/material";

const SmallLoader = ({show = true}) => {
    if (!show){
        return null
    }
    return <CircularProgress/>
}
export default SmallLoader
